import { useEffect } from 'react'

const PIXEL_ID = '3934337213376403'
let isInitialized = false

declare global {
  interface Window {
    fbq: Function & {
      callMethod?: Function
      queue?: unknown[]
      loaded?: boolean
      version?: string
      push?: Function
    }
    _fbq: typeof window.fbq
  }
}

export function useMetaPixel() {
  useEffect(() => {
    if (isInitialized) return
    isInitialized = true

    // Official Meta Pixel base code
    const f = window
    const b = document
    const n = 'script'

    if (f.fbq) return

    const q: any = function (...args: unknown[]) {
      if (q.callMethod) {
        q.callMethod(...args)
      } else {
        q.queue.push(args)
      }
    }

    q.push = q
    q.loaded = true
    q.version = '2.0'
    q.queue = [] as unknown[]

    f.fbq = q
    f._fbq = q

    const e = b.createElement(n) as HTMLScriptElement
    e.async = true
    e.src = 'https://connect.facebook.net/en_US/fbevents.js'

    const t = b.getElementsByTagName(n)[0]
    t?.parentNode?.insertBefore(e, t)

    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])
}
